import contract from '@mailobj-browser/front/js/contracts/contract.js'
import selector from "./selector/selector.js";

export default contract({
  selector,
})